define(
    'viewmodels/reset',[
        "viewmodels/ViewModel",
        "plugins/router",
        "i19n!i19n/strings",
        "providers/dataprovider"
    ],
    function (ViewModel, router, i19n, dataProvider) {
        var vm = new ViewModel(
        {
            i19n: i19n,
            login: {
                show: function () {
                    vm.reset.messageVisible(false);
                    router.navigate('login');
                }
            },
            reset: {
                linkId: '',
                newpassword: ko.observable('').extend({ required: true }),
                confirmpassword: ko.observable('').extend({ required: true }),
                visible: ko.observable(false),
                messageVisible: ko.observable(false),
                message: ko.observable(''),
                show: function () {
                    vm.reset.visible(true);
                    vm.reset.messageVisible(false);
                    vm.login.visible(false);
                }
            }
        });

        vm.activate = function (ctx) {
            vm.reset.linkId = ctx.substring(3, ctx.length);

            return validatePasswordResetLink();
        };      
        vm.attached = function () {
            vm.reset.confirmpassword.extend({ validation: { validator: mustMatchPassword, message: i19n.to.passwordsdonotmatch } });
        };

        vm.reset.errors = ko.validation.group(vm.reset);
        vm.reset.isValid = ko.computed(function () {
            return vm.reset.errors().length == 0;
        });
        vm.reset.submit = ko.asyncCommand({
            execute: function (complete) {
                if (vm.reset.isValid()) {
                    var password = vm.reset.confirmpassword();

                    dataProvider
                    .accounts
                    .updatePassword(vm.reset.linkId, password)
                        .done(function () {
                            vm.reset.visible(false);

                            vm.reset.message(i19n.to.passwordupdated);
                            vm.reset.messageVisible(true);

                            vm.reset.newpassword('');
                            vm.reset.confirmpassword('');

                            complete();
                        })
                        .fail(function () {
                            complete();
                        });
                } else {
                    vm.reset.errors.showAllMessages();
                    complete();
                }
            }
        });

        return vm;

        function mustMatchPassword(d) {
            return d == vm.reset.newpassword();
        }
        function validatePasswordResetLink() {
            var d = $.Deferred();
            
            dataProvider
            .accounts
            .validateResetPasswordLink(vm.reset.linkId)
                .done(function () {
                    d.resolve(true);
                    vm.reset.visible(true);
                })
                .fail(function (e) {
                    e.stopPropagation = true;
                    
                    vm.reset.message(i19n.to.thisisinvalidorurlhasexpired);
                    vm.reset.messageVisible(true);
                    d.resolve(false);
                });

            //setTimeout(function () {
            //        var r = true;

            //        if (r) {
            //            d.resolve(true);
            //            vm.reset.visible(true);
            //        } else {
            //            vm.reset.message(i19n.to.thisisinvalidorurlhasexpired);
            //            vm.reset.messageVisible(true);
            //            d.resolve(false);
            //        }
            //}, 1000);

            return d.promise();
        }
    }
);

/*
             canDeactivate: function () {
                vm.log.canDeactivate(filename);
                return true;
            },
            canActivate: function () {
                vm.log.canActivate(filename);
                return true;
            },
            deactivate: function () {
                vm.log.deactivate(filename);
                return true;
            },

            binding: function () {
                vm.log.binding(filename);
                return true;
            },
            bindingComplete: function () {
                vm.log.bindingComplete(filename);
                return true;
            },

            compositionComplete: function () {
                vm.log.compositionComplete(filename);
                return true;
            },
            detached: function () {
                vm.log.detached(filename);
                return true;
            }
 */;
